// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"dec6c7e2","230":"f4fe9427","490":"c181d7cb","787":"55493f23","834":"977f8fe5","974":"86ce2d29"}[chunkId] + ".chunk.js";
};